export abstract class Search {
  public static readonly DEFAULT_RESULTS_LIMIT_SIZE = 50;
  public static readonly DEFAULT_EXCHANGE_RESULTS_LIMIT_SIZE = 500;
  public static readonly DEFAULT_EXCHANGE_RESULTS_LIMIT_SIZE_LARGE = 1000;
  public static readonly DEFAULT_DOWNLOADS_RESULTS_LIMIT_SIZE = 10000;
  public static readonly DEFAULT_PAGE = 1;
}
